import { z } from 'zod';
export const ZPlatform = z.enum(['prestashop', 'shopify']);
//# sourceMappingURL=platform.js.map